<template lang="pug">
  app-dialog(v-model="$_show" header="Согласовать заявку на оплату" width="756")
    .advocatapp
        app-text-field(v-model="form.eventDate" label="Дата мероприятия" readonly)
        app-text-field(v-model="form.advocatEventType.title" label="Тип мероприятия" readonly)
        app-combobox(v-model="form.boostingKfs" item-text="title" label="Коэффициенты" readonly)
        app-text-field(v-model="form.tariff" label="Тариф для постановления" type="number")
        app-text-field(v-model="form.judgeComment" label="Комментарий" )

    .sud-dialog-card__footer(slote="footer")
      v-layout.justify-space-between
         v-btn.text-none(
           dark
           color="#1B93AD" 
           large depressed 
           @click="saveAppItem") Сохранить для постановления

</template>

<script>
import { AppDialogToggable } from '@/components'

import { mapGetters } from 'vuex';

export default {
  mixins: [AppDialogToggable],
  props: {
    appItem: null,
  },
  data () {
    const defaultForm = Object.freeze({
      id: null,
      eventDate: '',
      advocatEventType: '',
      boostingKfs: '',
      tariff: 0,
      judgeComment: ''
    })

    return {
      form: Object.assign({}, defaultForm),
      kfSearch: null, 
      defaultForm
    }
  },
  methods: {
    saveAppItem() {
      this.$store.dispatch('specialist/SAVE_APP_ITEM', this.form)
      .then(() => this.$emit('edited'))
      .catch(() => this.$emit('error'))
    },
  },
  watch: {
    $_show (value) {
      if (value) {
        let baseObj = this.appItem || this.defaultForm
        this.form = JSON.parse(JSON.stringify(baseObj))
      }
    },
  },
  computed: {
    ...mapGetters('advocat', ['advocatEventTypes','isAdvocatEventTypesLoaded','boostingKfs','isBoostingKfsLoaded']),
  },
}
</script>

<style lang="scss" scoped>
</style>

